<footer class="fna-footer">
  <div class="footer-content">
    <div class="footer-main">
      <div class="footer-col footer-col--left">
        <div class="brand-vigilado-wrapper">
          <img
            src="assets/fna/icons/footer/vigilado_superintendencia.png"
            alt="Vigilado Superintendencia Financiera de Colombia"
          />
        </div>
        <div class="footer-col-left-content">
          <img
            [src]="mainLogo || 'assets/fna/images/logos/logo-fna.svg'"
            (error)="onMainLogoError()"
            alt="Fondo Nacional del Ahorro"
            class="brand-logo"
          />
          <h3 class="footer-heading">Puntos de atención principal - Correspondencia</h3>
          <p class="footer-text">Calle 12 # 65 - 11, Puente Aranda, Bogotá - Colombia</p>
          <p class="footer-text">Lunes a viernes de 8:00 a.m. 4:00 p.m.</p>
          <p class="footer-text">Sábados de 8:00 a.m. - 1:00 p.m.</p>
          <div class="footer-icontec">
            <img src="assets/fna/icons/footer/logo-icontect.png" alt="Certificación ICONTEC ISO 9001 SC7006-1" />
          </div>
        </div>
      </div>
      <div class="footer-col footer-col--center">
        <h3 class="footer-heading">Sede Principal</h3>
        <p class="footer-text">Calle 12 # 65 - 83, Puente Aranda, Bogotá - Colombia</p>
        <p class="footer-text">
          <strong>Teléfono:</strong>
          601 307 7070
        </p>
        <p class="footer-text">
          <strong>Línea gratuita nacional:</strong>
          01 8000 52 7070 o desde tu celular gratis al #289 para operadores móviles
        </p>
        <p class="footer-text">
          <strong>Línea de legalización:</strong>
          01 8000 23 3362
        </p>
        <p class="footer-text">
          <strong>Línea de anticorrupción:</strong>
          01 8000 112669 - 601 420 1686
        </p>
        <p class="footer-text footer-text--label"><strong>Notificaciones judiciales:</strong></p>
        <p class="footer-text">
          <a href="mailto:notificacionesjudiciales@fna.gov.co">notificacionesjudiciales&#64;fna.gov.co</a>
        </p>
        <p class="footer-text footer-text--label"><strong>Entes de control:</strong></p>
        <p class="footer-text"><a href="mailto:entesdecontrol@fna.gov.co">entesdecontrol&#64;fna.gov.co</a></p>
        <p class="footer-text footer-text--label footer-text--app-title">Descarga nuestra app</p>
        <div class="footer-apps">
          <a
            href="https://play.google.com/store/apps/details?id=com.ibm.fna.movil&hl=es"
            target="_blank"
            rel="noopener"
            class="app-badge"
          >
            <img src="assets/fna/icons/footer/google_play.svg" alt="" class="app-icon" />
            <span class="app-label">
              <small>Disponible en</small>
              <strong>Google Play</strong>
            </span>
          </a>
          <a
            href="https://apps.apple.com/co/app/fna-m%C3%B3vil-%C3%A1gil/id1138892675"
            target="_blank"
            rel="noopener"
            class="app-badge"
          >
            <img src="assets/fna/icons/footer/apple.svg" alt="" class="app-icon" />
            <span class="app-label">
              <small>Disponible en</small>
              <strong>Apple Store</strong>
            </span>
          </a>
          <a href="https://appgallery.huawei.com/app/C101591535" target="_blank" rel="noopener" class="app-badge">
            <img src="assets/fna/icons/footer/huawei.svg" alt="" class="app-icon" />
            <span class="app-label">
              <small>Disponible en</small>
              <strong>AppGallery</strong>
            </span>
          </a>
        </div>
      </div>
      <div class="footer-col footer-col--right">
        <p class="footer-update-label">Última actualización</p>
        <p class="footer-update-date">19 de enero de 2026</p>
        <div class="footer-social">
          <a href="https://www.instagram.com/fnaahorro/" target="_blank" rel="noopener" class="social-link">
            <img src="assets/fna/icons/social/instagram.svg" alt="Instagram" />
          </a>
          <a href="https://www.facebook.com/FNAColombia" target="_blank" rel="noopener" class="social-link">
            <img src="assets/fna/icons/social/facebook.svg" alt="Facebook" />
          </a>
          <a href="https://x.com/FNAahorro" target="_blank" rel="noopener" class="social-link">
            <img src="assets/fna/icons/social/x.svg" alt="X" />
          </a>
          <a href="https://www.tiktok.com/@fnaahorro" target="_blank" rel="noopener" class="social-link">
            <img src="assets/fna/icons/social/tik-tok.svg" alt="TikTok" />
          </a>
          <a href="https://www.youtube.com/user/fnaahorro" target="_blank" rel="noopener" class="social-link">
            <img src="assets/fna/icons/social/youtube.svg" alt="YouTube" />
          </a>
          <a
            href="https://www.linkedin.com/company/fondo-nacional-del-ahorro/"
            target="_blank"
            rel="noopener"
            class="social-link"
          >
            <img src="assets/fna/icons/social/linkedin.svg" alt="LinkedIn" />
          </a>
        </div>
        <div class="footer-gov-logos">
          <a href="https://www.gov.co" target="_blank" rel="noopener">
            <img src="assets/fna/icons/gov/gov-co.svg" alt="GOV.CO" />
          </a>
          <a href="https://colombia.co" target="_blank" rel="noopener">
            <img src="assets/fna/icons/gov/colombia-co.svg" alt="Colombia.co" />
          </a>
          <a href="https://www.grupobicentenario.gov.co" target="_blank" rel="noopener">
            <img src="assets/fna/icons/gov/grupo-bicentenario.svg" alt="Grupo Bicentenario" />
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-links">
        <a
          href="https://www.fna.gov.co/transparencia/informacion-entidad/mision-vision-funciones-y-deberes"
          target="_blank"
          rel="noopener"
        >
          Sobre el FNA
        </a>
        <a
          href="https://www.fna.gov.co/atencion-ciudadana/canales-de-atencion/defensor-del-consumidor"
          target="_blank"
          rel="noopener"
        >
          Defensor del Consumidor
        </a>
        <a href="https://www.fna.gov.co/atencion-ciudadana/pqrs" target="_blank" rel="noopener">PQRS</a>
        <a href="https://www.fna.gov.co/transparencia" target="_blank" rel="noopener">Transparencia</a>
        <a href="https://www.fna.gov.co/transparencia/normativa/condiciones-y-politicas" target="_blank" rel="noopener">
          Condiciones y políticas
        </a>
        <a href="https://www.fna.gov.co/mapa-del-sitio" target="_blank" rel="noopener">Mapa del sitio</a>
      </div>
      <p class="footer-copyright">&copy; FNA Todos los derechos reservados 2026</p>
    </div>
  </div>
</footer>
